import { render, staticRenderFns } from "./commonImageCard.vue?vue&type=template&id=19f08fdc&scoped=true"
import script from "./commonImageCard.vue?vue&type=script&lang=js"
export * from "./commonImageCard.vue?vue&type=script&lang=js"
import style0 from "./commonImageCard.vue?vue&type=style&index=0&id=19f08fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f08fdc",
  null
  
)

export default component.exports